import React, {useState} from 'react';
import {useAuth} from 'context';

import {Login, Signup} from './components';

export function ProtectedRoute({component: Component, path, ...props}) {
  const {getAuthToken} = useAuth();
  const [authComponent, setAuthComponent] = useState('LOGIN'); // LOGIN || SIGNUP

  return getAuthToken() == null ? (
    authComponent === 'LOGIN' ? (
      <Login path={path} showSignup={() => setAuthComponent('SIGNUP')} />
    ) : (
      <Signup path={path} showLogin={() => setAuthComponent('LOGIN')} />
    )
  ) : (
    <Component path={path} {...props} />
  );
}
